import { AlertTriangle } from "lucide-react";
import { useLocation } from "react-router-dom";

// Suppress the top emergency notice across normal Care Portal navigation so
// employees do not see the same 911 banner every time they move between
// pages. Appropriate crisis-safety language is still surfaced within the
// Resource Library content itself (individual crisis-related articles and
// downloadable materials), the site Footer, and the public Chatbox.
function isCarePortalPath(pathname) {
  return pathname === "/care-portal" || pathname.startsWith("/care-portal/");
}

export default function CrisisBanner() {
  const { pathname } = useLocation();
  if (isCarePortalPath(pathname)) return null;
  return (
    <div className="bg-red-50 border-b border-red-100" data-testid="crisis-banner">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-2.5 flex items-start sm:items-center gap-3 text-red-900">
        <AlertTriangle className="w-4 h-4 mt-0.5 sm:mt-0 shrink-0" strokeWidth={2} />
        <p className="text-xs sm:text-sm leading-relaxed">
          <span className="font-semibold">In immediate danger?</span>{" "}
          Call <span className="font-semibold">911</span> or local emergency services. This portal is not for medical or mental health emergencies.
        </p>
      </div>
    </div>
  );
}
